import React from "react";

const EmptyState = ({ message, icon, action }) => (
  <div className="flex flex-col items-center justify-center py-12 text-gray-400">
    <i className={`${icon || "fas fa-chart-bar"} text-4xl mb-3`} />
    <p className="text-sm">{message || "No data available"}</p>
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
